import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Newspaper, HelpCircle, CheckCircle2, FileEdit } from "lucide-react";
import { courseApi, blogApi, faqApi } from "./adminApi";
import { useAuth } from "./AuthContext";
import "./Admin.css";
export default function AdminDashboard() {
  const { admin } = useAuth();
  const [courses, setCourses] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const [c, b, f] = await Promise.all([
          courseApi.listAll(),
          blogApi.listAll(),
          faqApi.listAll().catch(() => []),
        ]);
        if (!cancelled) {
          setCourses(c);
          setBlogs(b);
          setFaqs(f);
        }
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);
  const publishedBlogs = blogs.filter((b) => b.status === "published").length;
  const publishedCourses = courses.filter((c) => c.isPublished).length;
  return (
    <div>
      <div className="admin-topbar">
        <h1>Welcome{admin?.name ? `, ${admin.name}` : ""}</h1>
      </div>
      {error && <div className="admin-error">{error}</div>}
      {loading ? (
        <p>Loading…</p>
      ) : (
        <>
          <div className="admin-stats">
            <div className="admin-stat-card">
              <div className="admin-stat-card__num">{courses.length}</div>
              <div className="admin-stat-card__label">Total Courses</div>
            </div>
            <div className="admin-stat-card">
              <div className="admin-stat-card__num">{publishedCourses}</div>
              <div className="admin-stat-card__label">Published Courses</div>
            </div>
            <div className="admin-stat-card">
              <div className="admin-stat-card__num">{blogs.length}</div>
              <div className="admin-stat-card__label">Total Blog Posts</div>
            </div>
            <div className="admin-stat-card">
              <div className="admin-stat-card__num">{publishedBlogs}</div>
              <div className="admin-stat-card__label">Published Posts</div>
            </div>
            <div className="admin-stat-card">
              <div className="admin-stat-card__num">{faqs.length}</div>
              <div className="admin-stat-card__label">FAQs</div>
            </div>
          </div>
          <div
            className="admin-form__row"
            style={{ gap: "1.5rem", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))" }}
          >
            <div className="admin-form__section" style={{ margin: 0 }}>
              <h3>
                <GraduationCap size={18} style={{ verticalAlign: "-3px", marginRight: 6 }} />
                Courses
              </h3>
              <p style={{ color: "var(--c-mut)", marginBottom: "1rem", fontSize: "0.9rem" }}>
                Add new courses, edit fees, syllabus and descriptions.
              </p>
              <Link to="/admin/courses" className="admin-btn admin-btn--outline">
                Manage Courses
              </Link>
            </div>
            <div className="admin-form__section" style={{ margin: 0 }}>
              <h3>
                <Newspaper size={18} style={{ verticalAlign: "-3px", marginRight: 6 }} />
                Blog
              </h3>
              <p style={{ color: "var(--c-mut)", marginBottom: "1rem", fontSize: "0.9rem" }}>
                Write, edit and publish articles for the site blog.
              </p>
              <Link to="/admin/blogs" className="admin-btn admin-btn--outline">
                Manage Blog Posts
              </Link>
            </div>
            <div className="admin-form__section" style={{ margin: 0 }}>
              <h3>
                <HelpCircle size={18} style={{ verticalAlign: "-3px", marginRight: 6 }} />
                FAQs
              </h3>
              <p style={{ color: "var(--c-mut)", marginBottom: "1rem", fontSize: "0.9rem" }}>
                Add, edit and reorder the questions shown on the home page.
              </p>
              <Link to="/admin/faqs" className="admin-btn admin-btn--outline">
                Manage FAQs
              </Link>
            </div>
          </div>
          {(courses.length === 0 || blogs.length === 0) && (
            <p style={{ marginTop: "1.5rem", color: "var(--c-mut)", fontSize: "0.85rem" }}>
              <FileEdit size={14} style={{ verticalAlign: "-2px", marginRight: 4 }} />
              Tip: use <CheckCircle2 size={14} style={{ verticalAlign: "-2px" }} /> "Publish" on a
              draft to make it visible on the live site.
            </p>
          )}
        </>
      )}
    </div>
  );
}